import React, {useEffect, useState} from 'react';
import {
  IonButton,
  IonCard, IonCardContent, IonCardHeader,
  IonIcon,
  IonList,
  IonSpinner
} from "@ionic/react";
import {post} from "../../../utils/frRequest";
import {FazendaObject} from "../../../models/Fazenda";
import {checkmark, chevronBack, createOutline} from "ionicons/icons";
import RebanhoEdit from "./RebanhoEdit";
import {debug} from "../../../config";
import {useAppDispatch} from "../../../lib/hooks";
import {actions} from "../../../lib/app";


interface RebanhoProps {
  rebanho: any[];
  fazenda: FazendaObject;
  setSecaoAtiva: (secao: string) => void;
  setRebanho: (rebanho: any[]) => void;
}

const Rebanho: React.FC<RebanhoProps> = (props) => {
  const [rebanho, setRebanho] = useState<any[]>(props.rebanho);
  const [rebanhoLoaded, setRebanhoLoaded] = useState(props.rebanho.length > 0);
  const [rebanhoLoading, setRebanhoLoading] = useState(false);
  const [selected, setSelected] = useState();
  const dispatch = useAppDispatch();

  // load rebanho
  useEffect(() => {
    if (!rebanhoLoaded && !rebanhoLoading) {
      setRebanhoLoading(true);

      debug('Calendario.Rebanho', 'Loading rebanho...');
      post('/veApi/vet_experts/load_rebanho',
        {fazendaId: props.fazenda.id})
        .then(({success, data, error}) => {
          if (!success) {
            dispatch(actions.notifyError('Erro ao carregar rebanho.'));
            console.error(`Erro inesperado em load_rebanho: ${error}`);
            return;
          }

          setRebanho(data);
          setRebanhoLoaded(true);
        })
        .catch(e => {
          dispatch(actions.notifyError(`Erro ao carregar rebanho. ${e}`));
          console.log(e);
        })
        .finally(() => {
          setRebanhoLoading(false);
        });
    }
  }, [props.fazenda.id, rebanhoLoaded, rebanhoLoading, dispatch]);

  const setItemValues = (categoriaId: number, values: any): void => {
    const lista: any[] = [];
    rebanho.forEach((p: any) => {
      if (p.id === categoriaId)
        lista.push(values);
      else
        lista.push(p);
    });
    setRebanho(lista);
  }

  const setRebanhoOk = (): void => {
    let nCabecas = 0;
    rebanho.forEach(i => nCabecas += i.num_animais);
    if (!nCabecas) {
      dispatch(actions.notifyError('O seu rebanho ainda está vazio.'));
      return;
    }

    props.setRebanho(rebanho);
    props.setSecaoAtiva('home');
  }

  return (
    <>
      <div className="flex items-center">
        <div>
          <IonButton
            onClick={() => props.setSecaoAtiva('home')}
            fill="clear"
            style={{
              '--padding-start': '4px',
            }}
          >
            <IonIcon
              slot="icon-only"
              icon={chevronBack}
            />
          </IonButton>
        </div>
        <div className="font-bold text-right text-xl">
          Rebanho
        </div>
      </div>

      <div className="flex justify-center mt-4">
        <IonButton
          onClick={setRebanhoOk}
          disabled={!rebanhoLoaded || selected}
        >
          <IonIcon icon={checkmark} slot="start"/>
          Confirmar rebanho
        </IonButton>
      </div>

      <IonList>
        {
          !rebanhoLoaded &&
          <div className="p-8 flex justify-center">
            <IonSpinner/>
          </div>
        }
        {
          rebanho.map((i: any) => (
            <IonCard key={i.id}>
              <IonCardHeader>
                {i.nome}
              </IonCardHeader>
              <IonCardContent>
                {
                  selected === i.id ?
                    <RebanhoEdit
                      instance={i}
                      setValue={v => setItemValues(i.id, v)}
                      setCloseEdit={() => setSelected(undefined)}
                    />
                    :
                    <>
                      <div className="flex">
                        <div className="w-4/12 mr-4">
                          {i.peso_medio} Kg
                        </div>
                        <div className="flex-grow">
                          peso médio
                        </div>
                      </div>
                      <div className="flex">
                        <div className="w-4/12 mr-4">
                          {i.num_animais}
                        </div>
                        <div className="flex-grow">
                          {i.num_animais === 1 ? 'cabeça' : 'cabeças'}
                        </div>
                      </div>
                      <div className="flex justify-end">
                        <IonButton
                          size={'small'}
                          fill={'clear'}
                          onClick={() => setSelected(i.id)}
                          color={'medium'}
                        >
                          <IonIcon icon={createOutline} slot="icon-only"/>
                        </IonButton>
                      </div>
                    </>
                }
              </IonCardContent>
            </IonCard>
          ))
        }
      </IonList>
    </>
  );
}

export default Rebanho;
